import { render, staticRenderFns } from "./ChatRoute.vue?vue&type=template&id=19e85754&scoped=true"
import script from "./ChatRoute.vue?vue&type=script&lang=ts"
export * from "./ChatRoute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e85754",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19e85754')) {
      api.createRecord('19e85754', component.options)
    } else {
      api.reload('19e85754', component.options)
    }
    module.hot.accept("./ChatRoute.vue?vue&type=template&id=19e85754&scoped=true", function () {
      api.rerender('19e85754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/ChatRoute.vue"
export default component.exports